"use client";

import { useCallback, useState, useRef } from "react";
import { useController } from "react-hook-form";

const getBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// 출처 : https://stackblitz.com/edit/input-file-react-hook-form?file=src%2FForm.js,src%2FFileController.js,src%2FPickAvatar.js,src%2Futils.js
export const FilesController = ({
  name,
  control,
  defaultValue,
  setValue,
  watch,
  render,
  accept,
}: any) => {
  const inputRef = useRef(null);
  const { field } = useController({ name, control });
  const [uploadFiles, setUploadFiles] = useState(defaultValue);

  const onChange = useCallback(
    async (event: any) => {
      const files = Array.from(event.target.files);
      const selectUploadFiles = uploadFiles.map(
        (uploadFile: any) => uploadFile.file
      );
      const prevUploadFiles = [...files, ...selectUploadFiles];

      if (event.target.files.length > 0) {
        let files = [];
        for await (let file of prevUploadFiles) {
          files.push({ file, base64: await getBase64(file) });
        }
        setUploadFiles(files);

        const dataTranster = new DataTransfer();
        for await (let { file } of files) {
          dataTranster.items.add(file);
        }
        field.onChange(dataTranster.files);
      }
    },
    [uploadFiles, field]
  );

  const remove = async (index: any) => {
    const nextUploadFiles = uploadFiles.filter(
      (base64: any, i: any) => i !== index
    );
    setUploadFiles(nextUploadFiles);

    const files = Array.from(defaultValue).filter((base64, i) => i !== index);
    const dataTranster = new DataTransfer();
    for await (let file of files) {
      dataTranster.items.add(file as File);
    }
    field.onChange(dataTranster.files);
  };

  return (
    <>
      <div className="coverUpload-list-wrap bg-gray-100">
        <div className="coverUpload-list">
          <input
            {...{
              type: "file",
              name,
              onChange,
              ref: (instance: any) => {
                field.ref(instance);
                inputRef.current = instance;
              },
              multiple: true,
              accept: accept ? accept : null,
            }}
            className="hide"
          />

          <button
            type="button"
            className="upload-btn"
            onClick={() => {
              if (inputRef.current) {
                (inputRef.current as HTMLInputElement)?.click();
              }
            }}
          >
            <i className="fa fa-upload fa-lg"></i>
            <br />
            업로드
          </button>
        </div>

        {uploadFiles &&
          uploadFiles.map((uploadFile: any, index: any) => {
            return (
              <div key={index} className="coverUpload-list">
                <div className="preview w-200px">
                  <div
                    className="img"
                    style={{
                      backgroundImage: uploadFile?.file?.type.startsWith(
                        "image/"
                      )
                        ? `url(${uploadFile.base64})`
                        : `url("/assets/images/default_product.png")`,
                    }}
                  />
                  <div className="preview_button">
                    <div className="flex">
                      <div className="w-20 text-ellipsis overflow-hidden text-center fw-bold text-white">
                        {uploadFile?.file?.name}
                      </div>
                      <div className="flex flex-row py-1">
                        <button
                          className="btn btn-white btn-xs basis-1/2 mx-1"
                          type="button"
                          onClick={() => remove(index)}
                        >
                          <i className="fa fa-trash"></i>
                          {/* 삭제 */}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="coverUpload-box">
        <div className="coverUpload-info">
          <p className="mb-0 fs-10px">파일 : .png, .jpg, .jpeg, .xlsx, xls</p>
          <p className="mb-0 fs-10px">용량 : 50MB 이하로 업로드해주세요.</p>
        </div>
      </div>
    </>
  );
};
